<template>
  <div class="wx-launch-btn-wrapper">
    {{ btnText || '打开APP领取' }}
    <wx-open-launch-app
      appid="wx7e8eef23216bade2"
      :extinfo='jumpTargetScheme'
      id="launch-btn"
      :style="wxStyle"
      @error="wxTagLaunchCkError"
      @launch="wxTagLaunchCk"
      @ready="wxTagReady"
    >
    <script type="text/wxtag-template">
      <style>
        .wx-launch-app-btn {
          width: 1000px;
          height: 300px;
        }
      </style>
      <div class="wx-launch-app-btn"></div>
      </script>
    </wx-open-launch-app>
  </div>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  name: 'wxLaunchAppBtn',
  properties: {
    jumpTargetScheme: {
      type: String,
      value: '',
    },
    btnText: {
      type: String,
      value: '',
    },
  },
  data: {
    isSupportWxTag: true,
    jumpTargetScheme: '',
  },
  computed: {
    wxStyle() {
      return {
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
      }
    },
  },
  methods: {
    wxTagLaunchCkError(res) {
      this.triggerEvent('launchApp')
      console.log('=======wxTagLaunchCkError===== ', res, res.detail)
    },
    wxTagLaunchCk(res) {
      console.log('=====wxTagLaunchCk==== ', res)
    },
    wxTagReady(res) {
      console.log('=====wxTagReady===== ', res, res.detail)
    },
  },
})
</script>

<style lang="scss" scoped>
.wx-launch-btn-wrapper {
  width: 472rpx;
  height: 118rpx;
}
</style>

<script type="application/json">
  {
    "component": true
  }
</script>
